import { Component, Input, EventEmitter, Output, NgModule,ElementRef, ViewChild } from '@angular/core';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';

import { FormsModule } from '@angular/forms';
import { AnalysisOptionsComponent } from './../../tools/analysis-options/analysis-options.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from './../../services/facade.service';
import { ProyectosService } from './../../services/proyectos.service';

//Variables del Navegador
type MenuItem = 'summary' | 'analysis' | 'tokens' | 'charts' ;

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
  type: string;
}

interface Data {
  [key: string]: WordCount[];
}

interface DividedData {
  [key: string]: WordCount[][];
}

@Component({
  selector: 'kvl-free',
  standalone: true,
  imports: [MatDialogModule,
    FormsModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective,
    HttpClientModule],
  templateUrl: './kvl-free.component.html',
  styleUrl: './kvl-free.component.css'
})
export class KvlFreeComponent {
  showChartContainer = true;
    selectedMenuItem: MenuItem = 'analysis';
    selectedLanguage: string = 'es';
    selectedSize = 500;
    public rank_data;

    private proyectoSub;
  
    loaderActive: boolean;
    loaderActive2: boolean;
    loaderActiveFirstProject: boolean;
  
    private previousSelectedSize: number | null = 500;
    private previousSelectedLanguage: string | null = 'es';
  
    @Input() checked: boolean; //Variable del mat-slide-toggle del text-component
  
    isIconRotated = false;

    UpdateKVL: boolean = false;
  
    @Output() textItemSelected = new EventEmitter<boolean>();
  
    activeEyeIcon: HTMLImageElement | null = null;

    verifyLoaderActive2: boolean;
  
    //Valores para expandir cada Cuadro
    public isExpanded: ExpandedState = {
      ONEBOX: false,
      TWOBOX: false,
      THREEBOX: false,
      FOURBOX: false,
      FIVEBOX: false,
      SIXBOX: false,
      SEVENBOX: false,
      EIGHTBOX: false,
      NINEBOX: false,
      TENBOX: false,
      ELEVENBOX: false,
      TWELVEBOX: false,
      THIRTEENBOX: false,
      FOURTEENBOX: false,
      FIFTEENBOX: false,
      SIXTEENBOX: false
    };
  
    public colors = [
      '#32cd32',
      '#9400d3',
      '#1e90ff',
      '#b22222',
      '#add8e6',
      '#bc8f8f',
      '#daa520',
      '#cd853f',
      '#20b2aa',
      '#bdb76b',
      '#156d31',
      '#87cefa',
      '#4b0082',
      '#00bfff',
      '#008080',
      '#ffa07a',
      '#0000cd',
      '#8b0000',
      '#deb887',
      '#00ffff',
    ]
  
    public summary = {
      coverage: {
        counted: null,
        no_counted: null,
        value: null
      },
      tokens: null,
      types: null,
      elements: null,
      total_tokens: null,
      total_types: null,
      mean_token: null,
      mean_type: null,
      mean_100_tokens: null,
      fifty_types: null,
      sixty_types: null,
      seventy_types: null,
      eighty_types: null,
      fifty_tokens: null,
      sixty_tokens: null,
      seventy_tokens: null,
      eighty_tokens: null,
    };
    // Pagina 2 de Summary
    // public datos_pagina2 = {
    //   coverage: 47.18,
    //   tokens: 354,
    //   types: 233,
    //   elements: 239,
    //   total_tokens: 309289,
    //   total_types: 289440,
    //   mean_token: 1852.03,
    //   mean_type: 1242.23,
    //   mean_100_tokens: 185202.99,
    //   fifty_types: 360,
    //   sixty_types: 700,
    //   seventy_types: 1230,
    //   eighty_types: 2320,
    //   fifty_tokens: 1150,
    //   sixty_tokens: 1720,
    //   seventy_tokens: 2100,
    //   eighty_tokens: 3180,
    // };
  
    // Variables de la pagina de Summary
    public coverage: number | undefined | null;
    public tokens: number | undefined | null;
    public types: number | undefined | null;
    public elements: number | undefined | null;
    public total_tokens: number | undefined | null;
    public total_types: number | undefined | null;
    public mean_token: number | undefined | null;
    public mean_type: number | undefined | null;
    public mean_100_tokens: number | undefined | null;
    public fifty_types: number | undefined | null;
    public sixty_types: number | undefined | null;
    public seventy_types: number | undefined | null;
    public eighty_types: number | undefined | null;
    public fifty_tokens: number | undefined | null;
    public sixty_tokens: number | undefined | null;
    public seventy_tokens: number | undefined | null;
    public eighty_tokens: number | undefined | null;

    public total_tokens_estimated: number | undefined | null;
  
    public data: Data = {
  
    }
    project_data: any;
    ishighlighted: any = {};
  
    ngOnInit(): void {
      localStorage.setItem("actual","kvlF")
      this.isButtonDisabled();
      if(sessionStorage.getItem("id_project")){
    this.iniciarKVL();
     }
      if(sessionStorage.getItem("text_UID")){
        this.loaderActive = true;
      }
      this.proyectoService.loader$.subscribe(loader => {
        if(this.loaderActive2){
          this.loaderActive = false;
        }else{
          this.loaderActive = loader;
        }
      });
                  this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });

           this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });
      // this.coverage = this.datos_pagina2.coverage;
      // this.tokens = this.datos_pagina2.tokens;
      // this.types = this.datos_pagina2.types;
      // this.elements = this.datos_pagina2.elements;
      // this.total_tokens = this.datos_pagina2.total_tokens;
      // this.total_types = this.datos_pagina2.total_types;
      // this.mean_token = this.datos_pagina2.mean_token;
      // this.mean_type = this.datos_pagina2.mean_type;
      // this.mean_100_tokens = this.datos_pagina2.mean_100_tokens;
      // this.fifty_types = this.datos_pagina2.fifty_types;
      // this.sixty_types = this.datos_pagina2.sixty_types;
      // this.seventy_types = this.datos_pagina2.seventy_types;
      // this.eighty_types = this.datos_pagina2.eighty_types;
      // this.fifty_tokens = this.datos_pagina2.fifty_tokens;
      // this.sixty_tokens = this.datos_pagina2.sixty_tokens;
      // this.seventy_tokens = this.datos_pagina2.seventy_tokens;
      // this.eighty_tokens = this.datos_pagina2.eighty_tokens;


              this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

    }
  
    constructor(
      private http: HttpClient,
      public fachada: FacadeService,
      public proyectoService: ProyectosService,
      private cdr: ChangeDetectorRef,
      private ngZone: NgZone
    ) {
  
      this.checked = true;
      // this.divideData();
      this.initSubscribe();
      if(sessionStorage.getItem("id_project")){
        this.iniciarKVL();
     }
    }
  
    ngOnDestroy(): void {
      this.proyectoSub?.unsubscribe();
    }

    initSubscribe() {
      if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject }) => {
         if(!firstProject){
          this.loaderActive = false;
          if(sessionStorage.getItem("text_UID")){
            if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
          }else{
            this.loaderActive2 = false;
          }
        }
        if(firstProject){
          this.loaderActive = false;
          if(sessionStorage.getItem("text_UID")){
            this.loaderActiveFirstProject = true;
          }else{
            this.loaderActiveFirstProject = false;
          }
        }
        console.log("Update de data --Reporta: KVL--")
        this.project_data = proyecto;
        
         for (const key in this.ishighlighted) {
        this.ishighlighted[key] = false;
      }

          if(sessionStorage.getItem("id_project")){

        this.iniciarKVL();
        }
      });
    }
    }
  
    status: any;
  async iniciarKVL() {
     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "kvlF"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("kvl");
  
      if (memoryStorage && !this.UpdateKVL) {
        if(memoryStorage !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          let respuesta = JSON.parse(memoryStorage);
          this.rank_data = respuesta.rank;
          this.summary = respuesta.summary;
  
          this.tokenWords = respuesta.tokens_estimated.map(item => ({
            word: item.word,
            tag: item.tag,
            count: item.count
          }));
          this.total_tokens_estimated = respuesta.total_tokens_estimated ;
  
          let acumulativo = 0;
          for (let index = 0; index < respuesta.rank.length; index++) {
            let element = respuesta.rank[index];
            this.isExpanded[element.label] = this.isExpanded[element.label] ?? false;
            this.ishighlighted[element.label] = this.ishighlighted[element.label] ?? false;
            const cantidadLlaves = this.getObjectKeys(respuesta.rank[index].words).length;
            acumulativo += cantidadLlaves / this.summary.coverage.counted;
            if (acumulativo > 1) { // El coverage de este no me da la cantidad como para acercarme al 100, me paso a veces así que lo capeo
              acumulativo = 1;
            }
            respuesta.rank[index].text = cantidadLlaves / this.summary.coverage.counted;
            respuesta.rank[index].cumul = acumulativo;
            respuesta.rank[index].cantidad = cantidadLlaves;
            respuesta.rank[index].color = index;
          }
          this.rank_data = this.sortKnownWordsFirst(respuesta.rank);
  
          // Verificar que todos los valores en isExpanded sean false
          Object.keys(this.isExpanded).forEach(key => {
            this.isExpanded[key] = this.isExpanded[key] ?? false;
     
          });
  
          this.updateChartData(); // Llamar a updateChartData para actualizar las gráficas
          this.showAll= true; 
  
        } catch (error) {
            if (error.message.includes("Should be run in update mode")) {
            console.log("Intentando manejar el error...");
          } else {
            console.log("Error inesperado");
            sessionStorage.removeItem('kvl');
          }
  
          
        }finally{
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
        }
      }
      }
      if(!memoryStorage || this.UpdateKVL){
        sessionStorage.setItem("kvl", "-");
        // Esperar unos milisegundos para que el servicio actualice la información
  
      await new Promise(resolve => setTimeout(resolve, 10));
      try {
        let textUID = sessionStorage.getItem('text_UID');
        let respuesta = await this.fachada.getKVLOfProject(this.http,textUID, "", this.selectedSize, this.selectedLanguage);
        // Guardar la respuesta en sessionStorage
        sessionStorage.setItem("kvl", JSON.stringify(respuesta));
        this.rank_data = respuesta.rank;
        this.summary = respuesta.summary;
  
        this.tokenWords = respuesta.tokens_estimated.map(item => ({
          word: item.word,
          tag: item.tag,
          count: item.count
        }));
  
        this.total_tokens_estimated = respuesta.total_tokens_estimated ;
  
  
  
        let acumulativo = 0;
        for (let index = 0; index < respuesta.rank.length; index++) {
          let element = respuesta.rank[index];
          this.isExpanded[element.label] = this.isExpanded[element.label] ?? false;
          this.ishighlighted[element.label] = this.ishighlighted[element.label] ?? false;
          const cantidadLlaves = this.getObjectKeys(respuesta.rank[index].words).length;
          acumulativo += cantidadLlaves / this.summary.coverage.counted;
          if (acumulativo > 1) { // El coverage de este no me da la cantidad como para acercarme al 100, me paso a veces así que lo capeo
            acumulativo = 1;
          }
          respuesta.rank[index].text = cantidadLlaves / this.summary.coverage.counted;
          respuesta.rank[index].cumul = acumulativo;
          respuesta.rank[index].cantidad = cantidadLlaves;
          respuesta.rank[index].color = index;
        }
        this.rank_data = this.sortKnownWordsFirst(respuesta.rank);
  
        // Verificar que todos los valores en isExpanded sean false
        Object.keys(this.isExpanded).forEach(key => {
          this.isExpanded[key] = this.isExpanded[key] ?? false;
  
        });
  
        this.updateChartData(); // Llamar a updateChartData para actualizar las gráficas
        this.showAll= true; 
        this.status = 200
      } catch (error) {
         if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (kvl)");
            sessionStorage.removeItem('kvl');
            this.status = 0

          }
          else if (error.message.includes("Should be run in update mode")) {
          console.log("Intentando manejar el error...");
        } else {
          console.log("Error inesperado");
          sessionStorage.removeItem('kvl');
        }
        this.status = error?.status;
      }finally{
        if(this.status === 0){
           this.loaderActive2 = true;
        this.loaderActive = true;
        this.loaderActiveFirstProject = true;
        this.proyectoService.updateloader(true);
        this.UpdateKVL = true;
        setTimeout(() => {
              this.iniciarKVL();
            }, 100);
        }
        else{
           this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.UpdateKVL = false;
        }
       
      }
      }
         }else{
      console.log(`kvl no es la pantalla actual así que bloqueamos peticiones`)
    }
   
  }
    

    private sortKnownWordsFirst(rankData: any[]): any[] {
      return [...(rankData || [])].sort((a, b) => {
        const aKnown = String(a?.label || '').trim().toLowerCase() === 'known words';
        const bKnown = String(b?.label || '').trim().toLowerCase() === 'known words';
        return Number(bKnown) - Number(aKnown);
      });
    }

    clearEyes(){
    this.proyectoService.undoMarcadoMultiple(this.http);
    this.UpdateKVL = true;
  }

    onLanguageChange(): void {
      this.clearEyes();
      setTimeout(() => {
        this.iniciarKVL();
      }, 100); // espera
    }
  
    updateChartData() {
      this.showChartContainer = true;
      // Limpiar las etiquetas y datasets existentes antes de agregar nuevos
      this.barChartData.labels = [];
      let dataset = {
        data: [],
        label: 'Knowledge Rank %',
        backgroundColor: [],
        barThickness: 40, // Hace las barras más delgadas
      };
  
      let maxValue = 0;
  
      for (const item of Object.keys(this.rank_data)) {
        if (this.rank_data[item].label !== "Off-list") {
          this.barChartData.labels.push(this.rank_data[item].label);
          dataset.backgroundColor.push(this.getRandomColor()); // Generar un color aleatorio para cada etiqueta
         const value = this.rank_data[item].text * 100; // Asumimos que text está en proporción y lo convertimos a % 
         dataset.data.push(value); 
         if (value > maxValue) { 
          maxValue = value;
          } // Actualizar el valor máximo
        }
      }
  
      // Reemplazar los datasets existentes en lugar de agregarlos
  
      this.barChartData.datasets = [dataset];
      this.updateChartOptions(Math.ceil(maxValue));
      this.cdr.detectChanges();
    }
  
    updateChartOptions(maxValue: number) {
      const stepSize = Math.ceil(maxValue / 5); // Ajustar el tamaño del paso en función del valor máximo
    
      this.barChartOptions = {
        scales: {
          x: {
            grid: {
              display: false, // Ocultar las líneas verticales
            },
          },
          y: {
            min: 0,
            max: maxValue, // Ajuste según el valor máximo calculado
            ticks: {
              stepSize: stepSize, // Incrementos calculados
              callback: function (value) {
                return value + '%'; // Mostrar el símbolo % en las etiquetas
              }
            },
            border: {
              display: false, // Eliminar el borde del eje Y
            },
            grid: {
              color: '#E0E0E0', // Color de las líneas horizontales
            },
          },
        },
        plugins: {
          legend: {
            display: false, // Ocultar la leyenda
          },
          datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
        },
      };
    }
    
    clearChartSize() {
      if (this.previousSelectedSize !== this.selectedSize) {
        this.previousSelectedSize = this.selectedSize;
        this.barChartData.labels = [];
        this.barChartData.datasets[0].data = [];
        this.showChartContainer = false;
        this.cdr.detectChanges();
      } 
     
    }
  
    clearChartLanguage() {
      if (this.previousSelectedLanguage !== this.selectedLanguage) {
        this.previousSelectedLanguage = this.selectedLanguage;
        this.barChartData.labels = [];
        this.barChartData.datasets[0].data = [];
        this.showChartContainer = false;
        this.cdr.detectChanges();
      } 
    }
  
    getRandomColor(): string {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }
  
  
    toggleIcon() {
      this.isIconRotated = !this.isIconRotated;
    }
  
    resetIcon() { this.isIconRotated = false; }
  
    //Funcion para expandir cada cuadro
    toggleExpand(identifier: string) {
      this.isExpanded[identifier] = !this.isExpanded[identifier];
    }
  
    toggleExpandAll() {
      const allExpanded = Object.values(this.isExpanded).every(value => value);
      Object.keys(this.isExpanded).forEach(identifier => {
        this.isExpanded[identifier] = !allExpanded;
      });
      this.showAll = allExpanded; 
    }
  
    showAll: boolean = true; 
  
  
    // Pagina 3 de Tokens
    // Lista de palabras con su tag y conteo de la pestaña Tokens
    tokenWords = [
    ];
  
    selectMenuItem(menuItem: MenuItem) {
      this.selectedMenuItem = menuItem;
      if (menuItem === 'summary' || menuItem === 'tokens') {
        this.textItemSelected.emit(true);
      } else {
        this.textItemSelected.emit(false);
      }
    }
  
    isSelected(menuItem: MenuItem): boolean {
      return this.selectedMenuItem === menuItem;
    }
  
    //Dividir los datos obtenidos entre las 3 columnas al expandir la informacion
  
    public dividedData: DividedData = {};
  
  
    //   divideData() {
    //    for (const key in this.data) {
    //      if (this.data.hasOwnProperty(key)) {
    //        const items = this.data[key];
    //        const chunkSize = Math.ceil(items.length / 2);
    //        this.dividedData[key] = [
    //          items.slice(0, chunkSize),
    //          items.slice(chunkSize),
    //        ];
    //      }
    //    }
    //  }
  
  
  
    public barChartType = 'bar' as const;
  
    public barChartOptions: ChartConfiguration<'bar'>['options'] = {
      scales: {
        x: {
          grid: {
            display: false, // Ocultar las líneas verticales
          },
        },
        y: {
          min: 0,
          max: 20, // Ajuste según el rango de datos esperado
          ticks: {
            stepSize: 5, // Incrementos de 5% en 5%
            callback: function (value) {
              return value + '%'; // Mostrar el símbolo % en las etiquetas
            }
          },
          border: {
            display: false // Eliminar el borde del eje Y
          },
          grid: {
            color: '#E0E0E0', // Color de las líneas horizontales
          },
        },
      },
      plugins: {
        legend: {
          display: false, // Ocultar la leyenda
        },
        datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
      },
    };
  
    public barChartData: ChartData<'bar'> = {
      labels: [],
      datasets: [
        {
          data: [],
          label: '',
          backgroundColor: [
            '#FF5722', // Naranja
            '#009688', // Verde
            '#F44336', // Rojo
            '#4CAF50', // Verde claro
            '#3F51B5', // Azul
            '#9C27B0', // Púrpura
          ],
          // Hace las barras más delgadas
          barThickness: 40,
        },
      ],
    };
  
  
    public barChartData1: ChartData<'bar'> = {
      labels: [],
      datasets: [
        {
          data: [],
          label: '',
          backgroundColor: [
            '#FF5722', // Naranja
            '#009688', // Verde
            '#F44336', // Rojo
            '#4CAF50', // Verde claro
            '#3F51B5', // Azul
            '#9C27B0', // Púrpura
          ],
          // Hace las barras más delgadas
          barThickness: 40,
        },
      ],
    };
  
  
    public barChartData2: ChartData<'bar'> = {
      labels: [],
      datasets: [
        {
          data: [],
          label: '',
          backgroundColor: [
            '#FF5722', // Naranja
            '#009688', // Verde
            '#F44336', // Rojo
            '#4CAF50', // Verde claro
            '#3F51B5', // Azul
            '#9C27B0', // Púrpura
          ],
          // Hace las barras más delgadas
          barThickness: 40,
        },
      ],
    };
  
  
    toggleEyeIcon(word_dict, index = 0): void {
      for (const key in this.ishighlighted) {
        if (key != word_dict) {
          this.ishighlighted[key] = false
        }
      }
      this.ishighlighted[word_dict] = !this.ishighlighted[word_dict]
      let palabras = this.getObjectKeys(this.rank_data[index].words)
  
      if (this.ishighlighted[word_dict]) {
        this.proyectoService.realizarMarcadoKvlFree(palabras, "kvl-select")
      } else {
        this.proyectoService.undoMarcado(palabras, "kvl-select")
      }
    }
  
    getObjectKeys(obj: any): string[] {
      return Object.keys(obj);
    }
  
    export_detallado() {
      let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
      if (respaldo_ID) {
        if (respaldo_ID.value != '' && respaldo_ID.value != null) {
          //TODO: Poner con la variable del selector
          this.fachada.detail_export("taggedlexical-bc-es", respaldo_ID.value)
        } else {
          alert("No hay proyecto cargado")
        }
      } else {
        alert("No esta en la página principal")
      }
    }
  
    export_tagger() {
      let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
      if (respaldo_ID) {
        if (respaldo_ID.value != '' && respaldo_ID.value != null) {
          //TODO: Poner con la variable del selector
          this.fachada.tagger_export("taggedlexical-bc-es", respaldo_ID.value)
        } else {
          alert("No hay proyecto cargado")
        }
      } else {
        alert("No esta en la página principal")
      }
    }
    
    isButtonDisabled(): boolean {
      return !sessionStorage.getItem("text_UID"); 
    }
}
